const oidc = {
    logout_success: 'Вы успешно вышли из системы.',
};
export default oidc;
